import axios from '.'

export default {
  uploadFiles
}


async function uploadFiles (
  path,
  files,
  onUploadProgressCallback
) {
  const formData = new FormData();
  formData.append('path', path)
  files.forEach((file) => {
    formData.append('files', file)
  })
  const response = await axios.post('/api/media/upload-media', formData, { 
    crossdomain: true,
    onUploadProgress: data => onUploadProgressCallback(data),
  })
  return response
}
